import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55b82d92")

_pushScopeId("data-v-55b82d92")
const _hoisted_1 = { class: "service-list-container" }
const _hoisted_2 = { class: "service-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "item",
          key: item.servingId
        }, [
          _createVNode("img", {
            src: item.imgUrl,
            onClick: ($event: any) => (_ctx.toDetail(item))
          }, null, 8, ["src", "onClick"])
        ]))
      }), 128))
    ])
  ]))
})